import { useTranslation } from "react-i18next";

import { AccordionItem } from "@krea/shared/design-system/AccordionItem";
import { cn } from "@krea/shared/utils";

/** Collapsible vertical "what happens next" steps shown under the trust badges. */
export const WhatHappensNextSteps = () => {
  const { t } = useTranslation("loanWidget");

  const steps = [
    t("loanWidget.whatHappensNextStep1"),
    t("loanWidget.whatHappensNextStep2"),
    t("loanWidget.whatHappensNextStep3"),
  ];

  return (
    <AccordionItem
      title={t("loanWidget.whatHappensNextTitle")}
      titleStyling="font-normal text-sm"
      className="border-gray-200 bg-white rounded-xl mt-4"
      accordionHeaderStyling="py-3 md:py-3"
      bodyStyling="overflow-visible md:pb-3 md:pt-0"
    >
      <ol className="m-0 my-3 grid list-none grid-cols-1 gap-4 pl-0">
        {steps.map((step, idx) => (
          <li key={idx} className="flex items-center gap-3">
            <span className="flex size-6 shrink-0 items-center justify-center rounded-full border border-solid border-black bg-white text-xs font-semibold text-black">
              {idx + 1}
            </span>
            <span
              className={cn("text-sm text-black", idx === 0 && "font-semibold")}
            >
              {step}
            </span>
          </li>
        ))}
      </ol>
    </AccordionItem>
  );
};
